import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { QuoteTabType } from "../models/Lead";

export default function useBookingMutations(componentName = "useBookingMutations") {
  const { get, getFile, post, postGetFile, put, patch, del } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const updateCallStatus = useMutation(
    ({ leadId, status }: { leadId: string; status: number }) =>
      patch(`/booking/${leadId}/call/status`, { status: status }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["leads"]);
        queryClient.invalidateQueries(["lead"]);
        queryClient.invalidateQueries(["leadActions"]);
      }
    }
  );

  const updatePrice = useMutation(
    ({ leadId, price, reason }: { leadId: string; price: number; reason: string }) =>
      patch(`/booking/${leadId}/price`, { price: price, reason: reason }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["leads"]);
        queryClient.invalidateQueries(["lead"]);
        queryClient.invalidateQueries(["leadActions"]);
      }
    }
  );

  const updateQuoteTabType = useMutation(
    ({ leadId, quoteTabType }: { leadId: string; quoteTabType: QuoteTabType }) =>
      patch(`/booking/${leadId}/quote/tab`, { quoteTabType: quoteTabType }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["leads"]);
        queryClient.invalidateQueries(["lead"]);
        queryClient.invalidateQueries(["leadActions"]);
      }
    }
  );

  return {
    updateCallStatus,
    updatePrice,
    updateQuoteTabType,
  }
}